import { createContext } from 'react';
import { Candidate } from '@/services/candidates';

type CandidatePagesContext = {
  refetchCandidate: () => void;
  candidate?: Candidate;
  isLoadingCandidate: boolean;
};

const context = createContext<CandidatePagesContext>({
  refetchCandidate() {},
  isLoadingCandidate: false,
});

export default context;
